import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl, FormattedMessage } from 'react-intl';

import AlertBox from 'components/ui/AlertBox';
import { legShape, productsShape } from 'constants/propTypes';

import { shouldShowAlert } from './utils';

import { StyledAlertBox } from '../Leg.styles';

const ExchangedDueToAOPAlertBox = ({ journey, withExchangedProducts }) => {
  const showAlert = shouldShowAlert({ journey, withExchangedProducts });

  if (!showAlert) {
    return null;
  }

  return (
    <StyledAlertBox variant={AlertBox.variants.INFO}>
      <FormattedMessage id="journeySegment.exchangedDueToAOP" />
    </StyledAlertBox>
  );
};

ExchangedDueToAOPAlertBox.propTypes = {
  journey: legShape.isRequired,
  withExchangedProducts: PropTypes.arrayOf(
    PropTypes.shape({
      products: productsShape
    })
  )
};

export default injectIntl(ExchangedDueToAOPAlertBox);
